import { useQuery } from "react-query";
import { db } from '../../constants/firebase'

let location

const getLocation = () => {
    return db.collection("locations")
        .doc(location)
        .get()
        .then((doc) => {
            return doc.data()
        })
}

const useLocation = (locationId) => {
    location = locationId
    return useQuery({
        queryKey: ['locationId: ', locationId],
        queryFn: getLocation,
        refetchOnWindowFocus: false,
        //query will autoFetch after 15 minutes:
        staleTime: 900000,
    })
}

export { useLocation }